import { ApolloLink } from 'apollo-link';

import getUserDistinctId from 'Utils/getUserDistinctId';

const distinctIdLink = new ApolloLink((operation, forward) => {
  const { distinctId } = getUserDistinctId();

  operation.setContext(({ headers }) => ({
    headers: {
      ...headers,
      'session-distinct-id': distinctId,
    },
  }));

  return forward(operation);
});

export default distinctIdLink;
